/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum PaymentItemsAliases {
  DYNAMIC_FIELDS_PAYMENT_ITEMS = 'dynamic-fields-payment-items',
  FIELD_PAYMENT_ITEMS_TEXT = 'field-payment-items-text',
  FORM_PAYMENT_ITEMS = 'form-payment-items',
  PANEL_PAYMENT_ITEMS = 'panel-payment-items',
  PAYMENT_ITEMS_LAYOUT = 'payment-items-layout',
  TEXT_PAYMENT_ITEMS = 'text-payment-items',
}
export { PaymentItemsAliases };
